module.exports = __webpack_public_path__ + "static/media/corporateStep1.c37c9af9.svg";